import styled from "styled-components";
import { colors, easing, fadeIn } from "../../../theme";

export const PageContainer = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  background-color: ${colors.backgroundMain};
  overflow-x: clip;
`;

// Wraps the routed page and footer: fades in on mount, fades out while
// leaving for another route.
export const PageFade = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  opacity: ${({ $leaving }) => ($leaving ? 0 : 1)};
  transition: opacity ${({ $leaving }) => ($leaving ? "0.25s" : "0s")} ease;
  animation: ${fadeIn} 0.6s ${easing.out} backwards;
`;
